export default function getCoverPhotoStoragePath(userId: string): string {
  return `/users/${userId}/images/coverPhoto`;
}
